module.exports = __webpack_public_path__ + "img/video-training-icon.dd4b5526.png";